import img5 from 'assets/img/support-desk/reports/5.png';
import img6 from 'assets/img/support-desk/reports/6.png';
import img7 from 'assets/img/support-desk/reports/7.png';
import greetingsImg from 'assets/img/illustrations/reports-greeting.png';
export default [
  {
    src: img7,
    height: 40,
    color: 'secondary',
    text: 'GegeeWeb',
    title: 'Илүү',
    title1: 'Xурдан'
    // describe:
    //   'Та манай платформыг ашиглан илүү хялбар илүү хурданаар маш ойлготой интерфейс ашиглан өөрийн',
    // describe2: 'веб сайтаа бүтээ.'
  },
  {
    src: greetingsImg,
    height: 40,
    color: 'secondary',
    text: 'GegeeWeb',
    title: 'Тогтмол',
    title1: 'хөгжүүлэлт',
    describe:
      'Бид таны веб сайтын ард ажиллаж буй системд байнгын хөгжүүлэлт хийж',
    describe2: 'найдвартай ажиллагааг хангах болно.'
  },
  {
    src: img5,
    height: 30,
    color: 'secondary',
    text: 'GegeeWeb',
    title: 'Аюулгүй ',
    title1: 'байдал',
    describe: 'Бид таны сайт болон зочдын мэдээллийг 24/7 цагийн турш   ',
    describe2: ' хамгаалдаг.      '
  },
  {
    src: img6,
    height: 30,
    color: 'secondary',
    text: 'GegeeWeb',
    title: 'Сургалт &',
    title1: 'Зөвлөгөө',
    describe:
      'Та манай платформын олон боломжуудыг ашиглан өөрийн веб сайтыг эхлүүлэхтэй холбоотой зөвлөгөөг',
    describe2: 'манай зөвлөхүүдтэй холбогдон аваарай.'
  }
];
